import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { MailSendItem } from '../../../external/MailDetailResultApi';
import { actions } from '../../modules/Actions';

export interface MailDetailResultState {
  mailDetailResult: MailSendItem | null;
  hit: number;
  total: number;
  success: number;
  fail: number;
  sending: number;
  upperLimit: number;
}

export const initialState: MailDetailResultState = {
  mailDetailResult: null,
  hit: 0,
  total: 0,
  success: 0,
  fail: 0,
  sending: 0,
  upperLimit: 0,
};

export const MailDetailResultReducer = reducerWithInitialState(initialState).case(
  actions.fetchMailDetail,
  (state: MailDetailResultState, payload: MailDetailResultState) => {
    return {
      ...state,
      ...payload,
    };
  }
);
